<form [formGroup]="formName" style="display: none">
    <input [type]="field.type" [formControlName]="field.fieldName" [placeholder]="field.placeholder">
</form>